import React from "react";
import { Container } from "semantic-ui-react";

import schlauch from "../../static/converted/bootsangler_schlauchboot-min.jpg";
import boot from "../../static/converted/bootsangler_boot-min.jpg";

import Imgmodal from "../imgmodal";

const Bootsangler = () => (
  <Container id="Bootsangler" className="main_content">
    <h1>Auslege und Drillboot</h1>
    <p>Ist ein 300cm Schlauchboot mit 10 PS Außenbordmotor.</p>
    <Imgmodal img={schlauch} fluid />
    <h1>Bootszelt</h1>
    <p>Zu jedem Leihboot zu buchbar.</p>
    <Imgmodal img={boot} fluid />
  </Container>
);

export default Bootsangler;



// WEBPACK FOOTER //
// ./src/components/Bootsangler/index.js